// extracted by mini-css-extract-plugin
module.exports = {"root":"FoundCustodianSection_root__1KwH6"};